import { useQuery } from "@tanstack/react-query";
import { supabase } from "@project/lib/data-client";
import { PageShell, PageHero } from "@project/user/components/page-shell";
import { useI18n } from "@project/lib/use-i18n";
import {
  HERO_IMAGES,
  FALLBACK_NEWS,
  pickFrom,
} from "@project/lib/stock-images";

export default function NewsPage() {
  const { t } = useI18n();
  const { data } = useQuery({
    queryKey: ["public-posts"],
    queryFn: async () =>
      (
        await supabase
          .from("posts")
          .select("*")
          .eq("status", "published")
          .order("publish_date", { ascending: false })
      ).data ?? [],
  });
  return (
    <PageShell>
      <PageHero
        eyebrow={t("community.news.hero.eyebrow")}
        title={t("community.news.hero.title")}
        subtitle={t("community.news.hero.subtitle")}
        image={HERO_IMAGES.news}
      />
      <div className="mx-auto max-w-5xl space-y-6 px-4 py-12">
        {!data?.length ? (
          <p className="text-center text-muted-foreground">
            {t("community.news.empty")}
          </p>
        ) : (
          <div className="grid gap-6 md:grid-cols-2">
            {data.map((p: any, i: number) => (
              <article
                key={p.id}
                className="group overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition hover:shadow-md"
              >
                <div className="aspect-video w-full overflow-hidden bg-muted">
                  <img
                    src={p.featured_image ?? pickFrom(FALLBACK_NEWS, p.id, i)}
                    alt={p.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs text-muted-foreground">
                    {p.publish_date}
                    {p.category ? ` · ${p.category}` : ""}
                  </div>
                  <h3 className="mt-1 font-serif text-2xl font-bold text-primary">
                    {p.title}
                  </h3>
                  {p.short_description && (
                    <p className="mt-2 line-clamp-3 text-muted-foreground">
                      {p.short_description}
                    </p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </PageShell>
  );
}
